import { gql } from 'sccs-shared-apollo-client-v0';

export const TECHNICAL_DATA = gql`
  fragment TechData on TechnicalData {
    label
    formattedValue
    value
    unit
  }
`;

export const INTEGER_TECHNICAL_DATA = gql`
  fragment IntTechData on IntegerTechnicalData {
    label
    formattedValue
    value
    unit
  }
`;

export const FLOAT_TECHNICAL_DATA = gql`
  fragment FloatTechData on FloatTechnicalData {
    label
    formattedValue
    value
    unit
  }
`;

export const FORMATTED_VALUE_FACET = gql`
  fragment FormattedValueFacetFragment on FormattedValueFacet {
    values {
      label
      formattedValue
      value
      count
    }
    facetType
  }
`;

export const RANGE_FACET = gql`
  fragment RangeFacetFragment on RangeFacet {
    values {
      min
      max
      count
    }
    facetType
  }
`;

export const DATE_RANGE_FACET = gql`
  fragment DateRangeFacetFragment on DateRangeFacet {
    values {
      min
      max
      count
    }
    facetType
  }
`;

export const NUMBER_COUNT_FACET = gql`
  fragment NumberCountFacetFragment on NumberCountFacet {
    values {
      value
      count
    }
    facetType
  }
`;

export const SIMPLE_COUNT_FACET = gql`
  fragment SimpleCountFacetFragment on SimpleCountFacet {
    values {
      value
      count
    }
    facetType
  }
`;

export const POWER_DATA = gql`
  fragment PowerDataFragment on Power {
    label
    formattedValue
    combustionKw {
      ...IntTechData
    }
    combustionHp {
      ...IntTechData
    }
    electricKw {
      ...IntTechData
    }
    electricHp {
      ...IntTechData
    }
    combinedKw {
      ...IntTechData
    }
    combinedHp {
      ...IntTechData
    }
  }
  ${INTEGER_TECHNICAL_DATA}
`;

export const ENGINE_DATA = gql`
  fragment EngineDataFragment on Engine {
    engineConcept {
      ...TechData
    }
    cylinder {
      ...IntTechData
    }
    capacity {
      ...IntTechData
    }
    torque {
      ...IntTechData
    }
    fuelType {
      ...TechnicalData
    }
    typeOfPropulsion {
      ...TechData
    }
    power {
      ...PowerDataFragment
    }
  }
  ${INTEGER_TECHNICAL_DATA}
  ${TECHNICAL_DATA}
  ${POWER_DATA}
`;

export const WEIGHTS_DATA = gql`
  fragment WeightsDataFragment on Weights {
    maximumWeight {
      ...IntTechData
    }
  }
  ${INTEGER_TECHNICAL_DATA}
`;

export const DIMENSIONS_DATA = gql`
  fragment DimensionsDataFragment on Dimensions {
    height {
      ...IntTechData
    }
    wheelbase {
      ...IntTechData
    }
  }
  ${INTEGER_TECHNICAL_DATA}
`;
